export const CSV_TEMPLATE_CONFIG = {
  default: {
    assetName: 'employees-upload-v2-sample-cabs.csv',
    downloadName: 'sample.csv',
  },
  ssoIdentifierOther: {
    assetName: 'sample-csv-SSO-identifier-cabs.csv',
    downloadName: 'sample-csv-SSO-identifier.csv',
  },
};

export const DOWNLOAD_CSV_TEMPLATE_ERROR =
  "We're having trouble downloading the CSV template. Please try again later or contact your account manager.";
